module.exports = __webpack_public_path__ + "static/media/mssql.37cb630b.png";